import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllTopupRequests = createAsyncThunk(
  "TopupRequest/FindAllTopupRequest",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/FindAllTopupRequest`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Wallet Withdrawal Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTopupRequestStatus = createAsyncThunk(
  "TopupRequest/TopupRequestStatusUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/TopupRequestStatusUpdate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Wallet Withdrawal Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTopupRequestByID = createAsyncThunk(
  "TopupRequest/FindByIDTopupRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/FindByIDTopupRequest`,
        { ID: ID }
      );
      const result = response.data?.Data;
      return {
        ...result,
        TransactionDate: result?.TransactionDate
          ? moment(result?.TransactionDate, "YYYY-MM-DD").toDate()
          : "",
      };
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching withdrawal request details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertTopupRequest = createAsyncThunk(
  "TopupRequest/InsertTopupRequest",
  async (CountryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/InsertTopupRequest`,
        CountryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTopupRequest = createAsyncThunk(
  "TopupRequest/UpdateTopupRequest",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/UpdateTopupRequest`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTopupRequest = createAsyncThunk(
  "TopupRequest/DeleteTopupRequest",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TopupRequest/DeleteTopupRequest`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Topup Request:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
